import React from 'react'
import { Route, Redirect } from "react-router-dom";
import { authenticatedRoutes, unAuthenticatedRoutes } from "./constant";
import utilService from "../util/utils.service";
import AuthService from "../util/auth.service";

export function PrivateRoute({ children,component: Component, ...rest }) {
    const isTokenExist = AuthService.isTokenExist();

    return (
      <Route
        {...rest}
        render={({location}) => {
          return isTokenExist ? (
            <Component >{children}</Component>
          ) : (
            <Redirect to={{
                pathname: unAuthenticatedRoutes.LOGIN,
                search: utilService.createQueryString({
                    redirectTo: location.pathname
                })
            }}   />
          );
        }}
      />
    );
  }

  export function AuthRoutes({ children,component: Component, ...rest }) {
    const isTokenExist = AuthService.isTokenExist();

    return (
      <Route
        {...rest}
        render={({location}) => {
          return !isTokenExist ? (
            <Component >{children}</Component>
          ) : (
            <Redirect to={{
                pathname: authenticatedRoutes.DASHBOARD,
            
            }}   />
          );
        }}
      />
    );
  }